const SELECTORS = {
	textareaWrapper: '#responseTextareaWrapper',
	textarea: '#response',
	submitButton: '#saveButton',
	editButton: '#editButton',
	clinicResponseContainer: '.clinic-response-container',
};
const CLASSES = {
	hideResponse: 'hide-response',
	showResponse: 'show-response',
	disabled: 'disabled',
};

export class ClinicReview {
	constructor() {
		this.textarea = document.querySelector(SELECTORS.textarea);
		this.textareaWrapper = document.querySelector(SELECTORS.textareaWrapper);
		this.submitButton = document.querySelector(SELECTORS.submitButton);
		this.editButton = document.querySelector(SELECTORS.editButton);
		this.clinicResponseContainer = document.querySelector(SELECTORS.clinicResponseContainer);

		const requiredElements = [
			this.textareaWrapper,
			this.submitButton,
			this.editButton,
			this.clinicResponseContainer,
		];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new ClinicReview();
		console.log('ClinicReview');
	}

	bindEvents() {
		['showCustomResponseTextarea', 'enableSubmitButton'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	showCustomResponseTextarea() {
		this.textareaWrapper.classList.remove(CLASSES.hideResponse);
		this.clinicResponseContainer.classList.add(CLASSES.hideResponse);
	}

	enableSubmitButton() {
		if (this.textarea.value.length > 0) {
			this.submitButton.classList.remove(CLASSES.disabled);
		} else {
			this.submitButton.classList.add(CLASSES.disabled);
		}
	}

	setupEventListeners() {
		this.editButton.addEventListener('click', this.showCustomResponseTextarea);
		this.textarea.addEventListener('input', this.enableSubmitButton);
	}

	setup() {
		this.setupEventListeners();
	}
}
